module.exports = __webpack_public_path__ + "img/sprite-religions.5ae9f7c.svg";